import './App.css';
import ProductCategories from './machineUI/productCategories';
// import { ThemeProvider, createTheme } from '@mui/material/styles';
import { Switch, Route, useLocation } from 'react-router-dom';
import React, { useReducer, useEffect, useState } from 'react';
import ScrollToTopButton from './items/buttons/ScrollToTopButton';
import { AnimatePresence } from 'framer-motion';
import { UserContext } from './contexts/userContext';
import NotFound from './items/404/NotFound';
import MachineProducts from './machineUI/machineProducts';
import Brands from './machineUI/Brands';
import ProductDescription from './machineUI/productDescription';
import PaymentPrompt from './machineUI/paymentPrompt';
import ProductDispense from './machineUI/productDispense';
import CheckoutComponent from './machineUI/checkoutComponent';
import MachineSignIn from './auth/MachineSignIn';
import ImageSlider from './machineUI/items/ImageSlider';
import IdleTimer from './machineUI/items/IdleTimer';
import Initial from './machineUI/items/Initial';
import Logout from './auth/Logout';
import Synch from './items/Synch';
import request from './services/Request';
import Disability from './machineUI/items/Disability';
import localRequest from './services/LocalServer/localRequest';
import axios from 'axios';
import { setVariable } from './services/servicesFunc';
// import { barcodeLisener, handleBarcode } from './services/barcodeListener';
// import { defaultStat } from '../src/staticData/stats';
import OutOfOrder from './machineUI/outOfOrder';
import MscName from './machineUI/company/MSC/MscName';

//Company
import ScanPage from './machineUI/company/MSC/ScanPage';
import { outOfOrderRequest } from './machineUI/outOfOrderRequest';

const LOCAL_STORAGE_KEY = 'MagexApp.cart';
const MAXCARTNUM = 4;

function App() {
  const location = useLocation();
  const [cartQuantity, setCartQuantity] = useState(0);

  //restore user information from localstorage
  const loggedInUser = JSON.parse(localStorage.getItem('user'));
  let initialState = { login: false, userName: '', role: '', email: '' };
  if (loggedInUser) {
    initialState.login = true;
    initialState.userName = loggedInUser.firstname;
    initialState.role = loggedInUser.role;
    initialState.email = loggedInUser.email;
    initialState.referTo = loggedInUser.referTo;
    initialState.fullAccess = loggedInUser.fullAccess;
    initialState.limits = loggedInUser.limits;
  }

  //for multi machine operation
  const [filterd, setFiltered] = useState([]);

  //user state
  const [loginStatus, setLoginStatus] = useState(initialState.login);
  const [user, setUser] = useState(initialState);
  const [userName, setUserName] = useState(initialState.userName);
  const [role, setRole] = useState(initialState.role);
  const [userEmail, setUserEmail] = useState(initialState.email);
  const [referTo, setReferTo] = useState(initialState.referTo);
  const [fullAccess, setFullAccess] = useState(initialState.fullAccess);
  //for checkout and cart
  const [machineID, setMachineID] = useState('');
  const [machine, setMachine] = useState(null);
  const [orderID, setOrderID] = useState('');
  const [testMode, setTestMode] = useState(false);
  const [langs, setlangs] = useState('en');
  const [cartFull, setCartFull] = useState(false);

  const [reRender, setReRender] = useState(false);
  //for initial category page
  const [idle, setIdle] = useState(0);
  const [cart, setCart] = useReducer(cartReducer, []);
  const [products, setProds] = useReducer(productsReducer, []);
  const [linkPromo, setLinkPromo] = useState({ p: '', id: '' });
  const [addevent, setaddevent] = useState(false);
  const [username, setuserName] = useState('');
  const [showCart, setShowCart] = useState(false);
  //MSC
  const [first, setFirst] = useState(true);

  const defaultStat = {
    session_com: 0,
    cart_aband: 0,
    all_prod: 0,
    all_brand: 0,
    payment: 0,
    language: {
      en: 0,
      fr: 0,
      es: 0,
    },
    cart_page: 0,
    faq: 0,
    cate: [],
    prod: [],
    brand: [],
    banner: {},
    session_time: 0,
    time: new Date(),
  };

  const [stat, setStat] = useState(defaultStat);

  //always check oos status
  useEffect(() => {
    const runSet = async () => {
      await setVariable();
    };

    runSet();
    const mid = localStorage.getItem('machineID');
    if (mid) {
      var outInterval = setInterval(() => outOfOrderRequest(outInterval, mid), 2000);
    }
    return () => {
      clearInterval(outInterval);
    };
  }, []);

  useEffect(() => {
    const productsStock = JSON.parse(localStorage.getItem('products'));
    if (productsStock) {
      setProds({ productsStock, type: 'set' });
    }

    let barcode = '';
    let interval;
    let preDate = new Date();

    const readBarcode = (evt) => {
      if (interval) {
        clearInterval(interval);
      }

      if (evt.code === 'Enter') {
        if (barcode) handleBarcode(barcode, preDate);
        barcode = '';
        return;
      }
      if (evt.code !== 'Shift' && evt.code !== 'ShiftLeft' && evt.code !== 'ShiftRight') {
        barcode += evt.key;
      }
      interval = setInterval(() => (barcode = ''), 20);
      return;
    };
    if (localStorage.getItem('BARCODE') === 'TRUE') {
      document.addEventListener('keydown', (evt) => {
        readBarcode(evt);
      });
    }

    const handleBarcode = async (bq, pre) => {
      const nowDate = new Date();
      //add scan cooldown 5 seconds
      if (
        nowDate.getTime() - pre.getTime() > 5000 &&
        (window.location.pathname.indexOf('/machineUI/category') === 0 ||
          window.location.pathname.indexOf('/machineUI/slider') === 0 ||
          window.location.pathname.indexOf('/machineUI/brands') === 0 ||
          window.location.pathname.indexOf('/machineUI/product') === 0)
      ) {
        preDate = nowDate;
        if (localStorage.getItem('DAILYBLEND') === 'TRUE') {
          await axios({
            method: 'post',
            url: 'https://test.server.com/api/Order',
            data: {
              MachineSerialNumber: machineID,
              ReservationCode: barcode,
            },
            timeout: 5000,
          })
            .then((res) => {
              if (res.data.Reservations?.length > 1) {
                localRequest({
                  method: 'post',
                  url: `${process.env.REACT_APP_LOCAL_API}/updateKioskStatus`,
                  data: {
                    status: 'OrderCreated',
                    order_info: {
                      order_id: 1,
                      item_amount: 1,
                      tax_amount: 1,
                      total_amount: 1,
                      items: 1,
                    },
                  },
                });
              }
            })
            .catch(() => {});
        }
      }
    };

    return () => {
      document.removeEventListener('keydown', (evt) => {
        readBarcode(evt);
      });
    };
  }, []);

  useEffect(() => {
    if (showCart) {
      stat.cart_page += 1;
      setStat(stat);
    }
  }, [showCart]);

  useEffect(() => {
    localStorage.setItem('products', JSON.stringify(products));
  }, [products]);

  function productsReducer(state, action) {
    switch (action.type) {
      case 'set':
        return [...action.productsStock];
      case 'add':
        return [...action.product];
      case 'clean': {
        const update = [];
        return update;
      }
      case 'decrement': {
        const productIndex = state.findIndex((item) => item._id === action.product._id);
        if (productIndex < 0) {
          return state;
        }
        if (cartQuantity < MAXCARTNUM || action.product.current_stock < action.qtt) {
          const update = [...state];
          update[productIndex].current_stock = action.qtt;
          return update;
        }
      }
      default:
        return state;
    }
  }

  function decreStock(product, qtt) {
    setProds({ product, qtt, type: 'decrement' });
  }

  function setAllProds(product) {
    setProds({ product, type: 'add' });
  }

  function changeProdPrice(product) {
    setCart({ product, type: 'changeProdPrice' });
  }

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    if (storedCart) {
      setCart({ storedCart, type: 'addArray' });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cart));
    const totalQtt = cart.reduce((total, item) => {
      return (total += item.quantity);
    }, 0);
    setCartQuantity(totalQtt);
    console.log(cart);
  }, [cart]);

  //send web application status to database
  useEffect(() => {
    if (!(process.env.REACT_APP_DEV === 'TRUE')) {
      var interval = setInterval(() => updateActive(), 60000);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);
  const updateActive = () => {
    const mid = localStorage.getItem('machineID');
    if (mid) {
      request({
        method: 'post',
        url: `/machines/updateStatus`,
        data: {
          id: mid,
        },
      }).then((res) => {});
    }
  };

  function cartReducer(state, action) {
    switch (action.type) {
      case 'addArray': {
        return [...action.storedCart];
      }
      case 'add': {
        if (cartQuantity >= MAXCARTNUM) {
          setCartFull(true);
          return state;
        } else {
          //buy X promotion
          let count = 1;
          if (action.product.promoIndex) {
            state.forEach((item) => {
              if (action.product.promoIndex === item.promoIndex) {
                count += item.quantity;
              }
            });
            state.forEach((item) => {
              if (action.product.promoIndex === item.promoIndex) {
                item.promoQtt = count;
              }
            });
            action.product.promoQtt = count;
          }
          return [...state, action.product];
        }
      }
      case 'remove': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        //buy X promotion
        const promoIndex = state[productIndex].promoIndex;
        state.forEach((item) => {
          if (promoIndex && promoIndex === item.promoIndex) {
            item.promoQtt = action.promoQtt;
          }
        });
        const update = [...state];
        update.splice(productIndex, 1);
        return update;
      }
      case 'chgQuantity': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        const promoIndex = state[productIndex].promoIndex;
        if (cartQuantity >= MAXCARTNUM && state[productIndex].quantity < action.quantity) {
          setCartFull(true);
          return state;
        } else {
          //buy X promotion
          if (state[productIndex].quantity < action.quantity) {
            if (promoIndex) {
              state.forEach((item) => {
                if (promoIndex === item.promoIndex) {
                  item.promoQtt += 1;
                }
              });
            }
          }
          console.log('state', state);
          const update = [...state];
          update[productIndex].quantity = action.quantity;
          return update;
        }
      }
      case 'decQuantity': {
        if (action.index < 0) {
          return state;
        }
        const promoIndex = state[action.index].promoIndex;
        if (cartQuantity >= MAXCARTNUM && state[action.index].quantity < action.quantity) {
          setCartFull(true);
          return state;
        } else {
          //buy X promotion
          if (promoIndex) {
            state.forEach((item) => {
              if (promoIndex === item.promoIndex) {
                item.promoQtt = action.promoQtt;
              }
            });
          }
          console.log('state', state);
          const update = [...state];
          update[action.index].quantity = action.quantity;

          return update;
        }
      }
      case 'changePrice': {
        const productIndex = state.findIndex((item) => item.id === action.product.id);
        if (productIndex < 0) {
          return state;
        }
        const update = [...state];
        update[productIndex].discount = action.discount;
        update[productIndex].discountedPrice = action.discountedPrice;
        update[productIndex].buyX = action.buyX;
        update[productIndex].percentage = action.percentage;
        update[productIndex].promo = action.promo;
        return update;
      }
      case 'clean': {
        const update = [];
        return update;
      }
      case 'getQuantity': {
        const cart = [...state];
      }
      default:
        return state;
    }
  }

  function add(product) {
    if (!(cartQuantity >= MAXCARTNUM)) {
      const index = stat?.prod.findIndex((item) => item._id === product._id);
      if (index >= 0) {
        stat.prod[index].add_to_cart = stat.prod[index].add_to_cart += 1;
      } else {
        stat.prod.push({
          _id: product._id,
          detail: 0,
          name: product.name?.en,
          add_to_cart: 1,
          conv: 0,
        });
      }
      setStat(stat);
      console.log(stat);
    }

    setCart({ product, type: 'add' });
  }

  function remove(product) {
    //buyx
    const index = cart.findIndex((item) => item.id === product.id);
    if (index > -1) {
      const promoQtt = cart[index].promoQtt - 1;
      setCart({ product, type: 'remove', promoQtt: promoQtt });
    }
  }

  function alterQuantity(product, quantity, isIncrement) {
    //buyx
    const index = cart.findIndex((item) => item.id === product.id);
    let promoQtt = 0;
    if (index > -1) {
      if (cart[index].quantity < quantity) {
        if (cart[index].promoIndex) {
          promoQtt = cart[index].promoQtt + 1;
        }
        setCart({
          product,
          type: 'chgQuantity',
          quantity: quantity,
          promoQtt: promoQtt,
          index: index,
        });
      } else {
        if (cart[index].promoIndex) {
          promoQtt = cart[index].promoQtt - 1;
        }
        setCart({
          product,
          type: 'decQuantity',
          quantity: quantity,
          promoQtt: promoQtt,
          index: index,
        });
      }
    }
  }

  function cleanUp() {
    setCart({ type: 'clean' });
    setProds({ type: 'clean' });
  }

  function changePrice(product, discount, discountedPrice, buyX, percentage, promo) {
    setCart({
      product,
      type: 'changePrice',
      discount: discount,
      discountedPrice: discountedPrice,
      buyX: buyX,
      percentage: percentage,
      promo: promo,
    });
  }

  function idleScreenSaver() {
    if (
      window.location.pathname.indexOf('/machineUI/') === 0 &&
      window.location.pathname.indexOf('/machineUI/out-of-order') !== 0 &&
      window.location.pathname.indexOf('/machineUI/product-dispense') !== 0 &&
      window.location.pathname.indexOf('/machineUI/slider') !== 0 &&
      window.location.pathname.indexOf('/machineUI/MSC') !== 0 &&
      window.location.pathname.indexOf('/machineUI/home/') !== 0
    ) {
      return <IdleTimer machine={machine} idle={idle} />;
    } else {
      return null;
    }
  }

  function MSCNAME() {
    return <MscName name={username} />;
  }

  function disability() {
    if (
      window.location.pathname.indexOf('/machineUI/') === 0 &&
      window.location.pathname.indexOf('/machineUI/payment') !== 0 &&
      window.location.pathname.indexOf('/machineUI/product-dispense') !== 0 &&
      window.location.pathname.indexOf('/machineUI/out-of-order') !== 0
    ) {
      return <Disability />;
    } else {
      return null;
    }
  }

  return (
    <div className="App category-container">
      {idleScreenSaver()}
      {MSCNAME()}
      <UserContext.Provider
        value={{
          loginStatus,
          setLoginStatus,
          userName,
          user,
          setUser,
          setUserName,
          role,
          setRole,
          userEmail,
          setUserEmail,
          referTo,
          setReferTo,
          fullAccess,
          setFullAccess,
          reRender,
          setReRender,
          machineID,
          setMachineID,
          orderID,
          setOrderID,
          setFiltered,
          filterd,
          setTestMode,
          testMode,
          stat,
          setStat,
          username,
        }}
      >
        <AnimatePresence exitBeforeEnter>
          <Switch location={location} key={location.pathname}>
            <Route
              exact
              path="/machineUI/slider/:id/"
              render={(props) => (
                <ImageSlider
                  setuserName={setuserName}
                  stat={stat}
                  cleanUp={cleanUp}
                  setStat={setStat}
                  defaultStat={defaultStat}
                  cartQuantity={cartQuantity}
                  id={props.match.params.id}
                  linkPromo={linkPromo}
                  setLinkPromo={setLinkPromo}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/home/:id/:test"
              render={(props) => (
                <Initial
                  stat={stat}
                  setStat={setStat}
                  linkPromo={linkPromo}
                  setLinkPromo={setLinkPromo}
                  setlangs={setlangs}
                  setTestMode={setTestMode}
                  setMachine={setMachine}
                  setProds={setAllProds}
                  id={props.match.params.id}
                  test={props.match.params.test}
                  cleanUp={cleanUp}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/category/:id"
              render={(props) => (
                <ProductCategories
                  stat={stat}
                  setStat={setStat}
                  setlangs={setlangs}
                  langs={langs}
                  itemCounter={cartQuantity}
                  products={products}
                  id={props.match.params.id}
                  cleanUp={cleanUp}
                  decreStock={decreStock}
                  setShowCart={setShowCart}
                  showCart={showCart}
                  add={add}
                  remove={remove}
                  cart={cart}
                  alterquantity={alterQuantity}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/brands/:id"
              render={(props) => (
                <Brands
                  stat={stat}
                  setStat={setStat}
                  setlangs={setlangs}
                  langs={langs}
                  itemCounter={cartQuantity}
                  id={props.match.params.id}
                  cleanUp={cleanUp}
                  decreStock={decreStock}
                  setShowCart={setShowCart}
                  showCart={showCart}
                  add={add}
                  remove={remove}
                  cart={cart}
                  alterquantity={alterQuantity}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/product/:machineID/:id/:index"
              render={(props) => (
                <ProductDescription
                  stat={stat}
                  setStat={setStat}
                  langs={langs}
                  id={props.match.params.id}
                  i={props.match.params.index}
                  machineID={props.match.params.machineID}
                  add={add}
                  cart={cart}
                  products={products}
                  decreStock={decreStock}
                  MAXCARTNUM={MAXCARTNUM}
                  itemCounter={cartQuantity}
                  changeProdPrice={changeProdPrice}
                  alterquantity={alterQuantity}
                  remove={remove}
                  setShowCart={setShowCart}
                  showCart={showCart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/category/:brandOrCate/:catename/:id"
              render={(props) => (
                <MachineProducts
                  stat={stat}
                  setStat={setStat}
                  langs={langs}
                  setlangs={setlangs}
                  machineID={props.match.params.id}
                  catename={props.match.params.catename}
                  id={props.match.params.id}
                  brandOrCate={props.match.params.brandOrCate}
                  products={products}
                  setProds={setAllProds}
                  alterquantity={alterQuantity}
                  itemCounter={cartQuantity}
                  MAXCARTNUM={MAXCARTNUM}
                  decreStock={decreStock}
                  setShowCart={setShowCart}
                  showCart={showCart}
                  add={add}
                  remove={remove}
                  cart={cart}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/:id/checkout"
              render={(props) => (
                <CheckoutComponent
                  stat={stat}
                  setStat={setStat}
                  langs={langs}
                  machineID={props.match.params.id}
                  cart={cart}
                  testMode={testMode}
                  alterQuantity={alterQuantity}
                  remove={remove}
                  products={products}
                  decreStock={decreStock}
                  changePrice={changePrice}
                  MAXCARTNUM={MAXCARTNUM}
                  itemCounter={cartQuantity}
                  cleanUp={() => {
                    setCart({ type: 'clean' });
                  }}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/payment/:id"
              render={(props) => (
                <PaymentPrompt
                  id={props.match.params.id}
                  cart={cart}
                  idle={idle}
                  setIdle={setIdle}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/product-dispense/:id"
              render={(props) => (
                <ProductDispense
                  linkPromo={linkPromo}
                  langs={langs}
                  stat={stat}
                  setStat={setStat}
                  id={props.match.params.id}
                  machine={machine}
                  cleanUp={cleanUp}
                />
              )}
            />
            <Route
              exact
              path="/machineUI/out-of-order/:id"
              render={(props) => <OutOfOrder id={props.match.params.id} />}
            />
            <Route exact path="/machineSignIn/:page" component={MachineSignIn} />
            <Route exact path="/machineSignIn" component={MachineSignIn} />
            <Route exact path="/synch" render={(props) => <Synch loginStatus={loginStatus} />} />
            <Route path="/logout" component={Logout} />
            {/* //Company */}
            <Route
              exact
              path="/machineUI/MSC/:id"
              render={(props) => (
                <ScanPage
                  addevent={addevent}
                  setaddevent={setaddevent}
                  setuserName={setuserName}
                  first={first}
                  setFirst={setFirst}
                />
              )}
            />
            <Route component={NotFound} />
          </Switch>
        </AnimatePresence>
      </UserContext.Provider>
    </div>
  );
}

export default App;
